export default "__VITE_ASSET__DxV1Ckc0__"